module.exports = __webpack_public_path__ + "img/loginOffer.22486938.png";